import React from 'react';
import { useAuth } from '@domain/auth/auth.hook';
import { useFormData } from '@domain/hooks/use.form.data';
import { RequestDialog } from '@components/dialog/request.dialog';
import { DescText } from '@styles/common';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const ChangePaymentsDialog = ({ player, requestChange, ...rest }: ToggleDialogProps) => {
  const { authorizedServices } = useAuth();

  const { paymentDisabled } = player.toggles;

  const formData = useFormData(player.pid, function requestChangePayments(data, cancelToken) {
    return authorizedServices.patch('/admin/toggles/payments', { params: data, cancelToken, pid: player.pid, payments: paymentDisabled });
  });

  const props = {
    icon: 'paid',
    title: paymentDisabled ? 'Enable payments' : 'Disable payments',
    successMsg: `Payments ${paymentDisabled ? 'enabled' : 'disabled'} successfully!`,
    onSuccess: requestChange,
  };

  return (
    <RequestDialog formData={formData} {...props} {...rest}>
      <DescText>
        Are you sure you want to <strong>{paymentDisabled ? 'enable' : 'disable'}</strong> payments for this player?
      </DescText>
    </RequestDialog>
  );
};

export default ChangePaymentsDialog;
